export const setItem = (key, value) => {
  try {
    typeof localStorage !== 'undefined' && localStorage.setItem(key, value)
    return { error: false }
  } catch (error) {
    return { error: true }
  }
}

export const getItem = (key) => {
  try {
    const value =
      typeof localStorage !== 'undefined' && localStorage.getItem(key)

    return { data: value, error: !value ? true : false }
  } catch (error) {
    return { data: null, error: true }
  }
}

export const removeItem = (key) => {
  try {
    typeof localStorage !== 'undefined' && localStorage.removeItem(key)
    return { error: false }
  } catch (error) {
    return { error: true }
  }
}

export const removeAll = () => {
  try {
    typeof localStorage !== 'undefined' && localStorage.clear()
    return { error: false }
  } catch (error) {
    return { error: true }
  }
}
